import type { ComponentStyleConfig } from '@chakra-ui/theme';

const FormLabel: ComponentStyleConfig = {
  baseStyle: {
    mb: 0,
  },
};

export default FormLabel;
